import { readStickyFlag } from "@/locales/stickyFlag";

/*
 * Both runtime-locale feature flags, in a leaf module that imports nothing but
 * stickyFlag. index.tsx reads them SYNCHRONOUSLY to decide whether the boot path
 * needs the manifest fetch at all, and a static import of publishedLocales /
 * runtimeLocale there would pull the i18n SDK into the entry chunk.
 *
 * The two flags are deliberately separate: one controls the network request, the
 * other the UI control. Absent flag means DISABLED for both, matching the
 * translator-mode and draft flags.
 */

// Gates the switcher control AND the whole runtime-locale chain: while it is off
// the app resolves the locale from the build env exactly as before.
export const LOCALE_SWITCHER_URL_PARAM = "locale-switcher";
export const LOCALE_SWITCHER_FLAG_STORAGE_KEY = "localeSwitcherEnabled";

// Gates the boot fetch of the published-locale manifest. While off, only the
// bundled locales are accepted, so a CDN-only locale resolves to English.
export const RUNTIME_LOCALES_URL_PARAM = "runtime-locales";
export const RUNTIME_LOCALES_FLAG_STORAGE_KEY = "runtimeLocalesEnabled";

export const isLocaleSwitcherEnabled = (): boolean =>
  readStickyFlag(LOCALE_SWITCHER_URL_PARAM, LOCALE_SWITCHER_FLAG_STORAGE_KEY);

export const isRuntimeLocalesEnabled = (): boolean =>
  readStickyFlag(RUNTIME_LOCALES_URL_PARAM, RUNTIME_LOCALES_FLAG_STORAGE_KEY);
